import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  desktopContent: {},

  stepContainerDesktop: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space24,
    padding: `${theme.spacing.space24}px 0px`,
  },

  stepTitle: {
    paddingTop: theme.spacing.space12,
    "&.is720Resolution": {
      fontSize: "16px !important",
    },
  },

  stepColDesktop: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing.space12,
    flex: 1,
  },

  videoWrapper: {
    width: "100%",
    height: "100%",
  },

  videoIframe: {
    aspectRatio: "16 / 9",
    width: "100%",
    height: "100%",
    border: "none",
  },

  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
  },

  stepDesc: {
    "&.is720Resolution": {
      fontSize: "16px !important",
    },
  },

  descLarge: {
    textAlign: "left",
    color: theme.colors.TextSilver,
  },
}));
